import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import { Autoplay, Navigation, Thumbs, Keyboard } from 'swiper'
import { getVideoId, getVideoPreview } from '@utils/video'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionGallery',
  props: {
  images: {
    type: Array,
  },
  videos: {
    type: Array,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const modules = [Autoplay, Navigation, Thumbs, Keyboard]

const swiperActiveIndex = ref(0)

const swiperInstance = ref(null)

const onSlideChange = (event) => {
  swiperActiveIndex.value = event.activeIndex
}
const onSwiperReady = (swiper) => {
  swiperInstance.value = swiper
}

const thumbsSwiper = ref(null)

const placeholderImage = window.placeholderImage

// const setThumbsSwiper = (swiper: any) => {
//   thumbsSwiper.value = swiper
// }

const generateVideoUrl = (videoId: string) => {
  return `//www.youtube.com/embed/${videoId}?autoplay=1`
}

const preparedImages = computed(() => {
  const allItems = [...props.images, ...props.videos]

  return allItems.map(item => {
    if (item.video_url) {
      const videoId = getVideoId(item.video_url)
      const videoUrl = generateVideoUrl(videoId)

      if (!item.image_url.base) {
        const preview = getVideoPreview(videoId)

        item.image_url.base = preview
      }

      item.video_url = videoUrl
    }

    return item
  })
})

const breakpoints = {
  320: {
    spaceBetween: 10,
  },
  1440: {
    spaceBetween: 30,
  },
}

const __returned__ = { props, modules, swiperActiveIndex, swiperInstance, onSlideChange, onSwiperReady, thumbsSwiper, placeholderImage, generateVideoUrl, preparedImages, breakpoints, ref, computed, onMounted, get Autoplay() { return Autoplay }, get Navigation() { return Navigation }, get Thumbs() { return Thumbs }, get Keyboard() { return Keyboard }, get getVideoId() { return getVideoId }, get getVideoPreview() { return getVideoPreview } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})